const PaginationRightSmallIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.7045 5.20451C10.1438 4.76517 10.8562 4.76517 11.2955 5.20451L17.2955 11.2045C17.5065 11.4155 17.625 11.7016 17.625 12C17.625 12.2984 17.5065 12.5845 17.2955 12.7955L11.2955 18.7955C10.8562 19.2348 10.1438 19.2348 9.7045 18.7955C9.26517 18.3562 9.26517 17.6438 9.7045 17.2045L14.909 12L9.7045 6.7955C9.26516 6.35616 9.26516 5.64384 9.7045 5.20451Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default PaginationRightSmallIcon;
